import store from "@/store";
import { CheckAuthorizeStatusAsync, CheckAuthorizeStatusAsyncAndCloseModal } from "./authService";

export async function changeProfilePictureAsync(base64,closeModal){
    let image = base64ToFile(base64);
    const url = `${process.env.VUE_APP_API_URL}Auth/ChangeProfileImage`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    var form = new FormData();
    form.append("Image", image);

    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: form
    });
    await CheckAuthorizeStatusAsyncAndCloseModal(response.clone(),closeModal);
    return response.json();

}

export async function getMyProfilePictureAsync(){
    const url = `${process.env.VUE_APP_API_URL}Auth/Image`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    let blob = await response.blob();
        if(blob.size == 0){
            throw new Error("Not found");
        }
        return await blobToBase64(blob);
   
}

function base64ToFile(base64) {
  const arr = base64.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const ext = mime.split('/')[1]

  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], `profile.${ext}`, { type: mime })
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject

    reader.readAsDataURL(blob)
  })
}

export async function deleteProfilePictureAsync(){
const url = `${process.env.VUE_APP_API_URL}Auth/DeleteProfileImage`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
  await CheckAuthorizeStatusAsync(response);
  return response.json();

}

